export const LINK_ICON_POSITIONS = {
  LEADING: 'leading',
  TRAILING: 'trailing',
};
